// extracted by mini-css-extract-plugin
export default {"FeatureContainer":"_FeatureContainer--ndJkp","Icon":"_Icon--haypy","Label":"_Label--rXeSv"};